import { RecursoCampanha } from './recurso-campanha';

export class RecursoCampanhaBase {
    readonly id: number;
    sequencia: number;
    idRecursoCampanha: number;
    recursoCampanha: RecursoCampanha;
    valor: number;
    anotacao: string;

    constructor(sequencia: number) {
        this.sequencia = sequencia;
    }
}
